import {useEffect, useState} from 'react';

let cached = null;

function load() {
  if (!cached) {
    cached = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/reviews`)
      .then(response => (response.ok ? response.json() : null))
      .then(data => (data?.configured && data.reviews?.length ? data : null))
      .catch(() => null);
  }
  return cached;
}

export function useGoogleReviews() {
  const [data, setData] = useState(null);
  useEffect(() => {
    let active = true;
    load().then(result => {if (active && result) setData(result);});
    return () => {active = false;};
  }, []);
  return data;
}
